import { useMemo, useState, useEffect } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// React-apex chart
import BasicLineChart from "../BasicLineChart";

// Vision UI Dashboard PRO React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";


function DefaultLineChart({ title, description, data, options, months }) {
  const [chartData, setChartData] = useState([...data]);
  const [chartOptions, setChartOptions] = useState({ ...options });
  useEffect(() => {
    setChartData(data);
    setChartOptions(options);
  }, [chartData, chartOptions]);
  return (
    <Card>
      <VuiBox px={description ? 1 : 0} pt={description ? 1 : 0}>        
        <VuiBox mb={1}>
          <VuiTypography variant="h5" textTransform="capitalize"
            fontWeight="800"
            color="#3b3663">
            {title}
          </VuiTypography>
        </VuiBox>
        <VuiBox mb={2}>
          <VuiTypography component="div" variant="button" fontWeight="regular" color="text">
            {description}
          </VuiTypography>
        </VuiBox>
        <VuiBox sx={{minHeight: "300px"}}>
        {
          useMemo(() => (
            <BasicLineChart
              chartData={data}
              chartOptions={options}
              categories={months} />
          ), [data, options, months])
        }
        </VuiBox>
      </VuiBox>
    </Card>
  );
}

// Setting default values for the props of DefaultLineChart
DefaultLineChart.defaultProps = {
  title: "",
  description: "",
};

// Typechecking props for the DefaultLineChart
DefaultLineChart.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  data: PropTypes.objectOf(PropTypes.array).isRequired,
  options: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default DefaultLineChart;
